export class Storage {
  static SESSION = 'session';
  static SESSION_TOKEN = 'token';
  static REFRESH_TOKEN = 'refreshToken';
  static LOGIN_PROVIDER = 'loginProvider';
  static SESSION_EXPIRES = 'expires';
  static USER_DATA = 'userData';
  static TERMS_OF_SERVICE = 'termsOfService';
}
